export default "__VITE_ASSET__BiN0Bum7__"